import React from 'react'
import { useContext } from './Context'
import { BusyButton } from '@ztechapps/webui.button'

export const RefreshButton = () => {
  const { onRefresh, loading: loadingCore } = useContext()

  const [loading, setLoading] = React.useState<boolean>(false)

  const onClick = async () => {
    try {
      setLoading(true)

      await onRefresh()
    } finally {
      setLoading(false)
    }
  }

  return <BusyButton isBusy={loading || loadingCore} bsStyle="primary" onClick={onClick} busyText="" icon="refresh" title="Refresh" />
}
